export default __webpack_public_path__ + "static/media/tn-ventas-01-PT.a6ece83e.jpg";